export class UserNotificationsDialogModel {}